import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { Subject, combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../../../services';
import { take, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { AMPubscriptionModel, GetAMPSubscription, IAMPAnnuityItemsViewModel, IAMPCustomerDetailsViewModel, IAMPModifySubscriptionResponse } from '../../../../../models/amp.model';
import { ConfirmAMPSubscriptionPopup } from '../../../../../popup-collection/confirm-amp-subscription-popup/confirm-amp-subscription-popup.component';
import { AdobeService } from '../../../../../services/adobe.service';
import { FinishAMPSubscriptionComponent } from '../../../../../popup-collection/finish-amp-subscription/finish-amp-subscription.component';
import { FileService } from '../../../../../services/file.service';
import { NgProgressService } from '../../../../../services/ngProgress.service';
import { AuthService } from '../../../../../services/auth.service';

@Component({
  selector: 'app-renew-amp-products-hgo',
  templateUrl: './renew-amp-product-hgo.component.html',
  styleUrls: ['./renew-amp-product-hgo.component.css'],
  providers: [DatePipe, CurrencyPipe, DecimalPipe]
})

export class RenewAMPProductsHGOComponent implements OnInit, OnDestroy {
  loadContent: boolean = false;
  public loadingPreview = false;
  tenantId: string;
  purchase: string;
  details: IAMPCustomerDetailsViewModel;
  mpnList: string[];
  skuList: Array<string> = [];
  showMpnIdloading: boolean;
  azureRiMPNControl: FormControl;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  public columnsToDisplay = ['desc', 'qty', 'rrp', 'price', 'total', 'deleteButton'];
  public columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  public expandedItem: IAMPAnnuityItemsViewModel | null;

  subscriptionItemsPendingList: IAMPAnnuityItemsViewModel[] = [];

  existingCustomerSubscriptions: GetAMPSubscription[] = [];

  currentLineItemsId: number

  originalBaseQty: string[];
  originalBaseActive: boolean[];
  totalPriceChange = 0;
  pendingTotal = 0;
  activeTotal = '0';
  confirmAnnuityItemSubscription: AMPubscriptionModel;
  confirmSubscriptions: AMPubscriptionModel[];
  finishSubscriptions: IAMPModifySubscriptionResponse[];
  poReference = '';
  CompanyName = '';
  AttentionRef = '';
  NoMPNText = '';
  Email = '';
  AddressLine1 ='';
  AddressLine2='';
  AddressLine3='';
  City ='';
  State ='';
  PostCode = '';
  PhoneNumber = '';
  public cotermDate: string;
  public createScheduled: boolean = false;
  public isQuoteCustomer = true;
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private adobeService: AdobeService,
    public commonService: CommonService,
    public calendar: NgbCalendar,
    private datePipe: DatePipe,
    private _decimalPipe: DecimalPipe,
    private fileService: FileService,
    private ngProgress: NgProgressService,
    public authService: AuthService,
    private currencyPipe: CurrencyPipe
  ) {
  }

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + $('#view-high-growth-offers').width() + 505})
  }

  ngOnInit() {
    this.loadContent = true;

    this.activatedRoute.parent.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
      if (params.get('tenantId')) {
        this.tenantId = params.get('tenantId')
      } else {
        this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
          this.tenantId = params.get('tenantId')
        })
      }
    });

    this.adobeService.getCurrentAMPCustomersForQuotes
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quoteCustomers) => {
        if (quoteCustomers != null && !quoteCustomers.find(q => q.tenantId == this.tenantId)) this.isQuoteCustomer = false;
      });

    // this.getPendingSubscriptions();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    // $('#levelOne').animate({ scrollLeft: 250 }, 400);
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
  }

  private getPendingSubscriptions(): void {
    combineLatest([
      this.adobeService.currentAMPCustomerDetailsWatch,
      this.adobeService.currentPendingAMPSubscriptions,
      this.adobeService.getCurrentAMPSubscriptions
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([customerDetail, pendingSubs, subs]) => {
        this.existingCustomerSubscriptions = subs;
        this.currentLineItemsId = this.existingCustomerSubscriptions.length

        if (!pendingSubs?.length) {
          this.close();
        }
        this.details = customerDetail;
        this.cotermDate = this.details?.customer?.coterm_date;

        const daysDiff: number = Math.ceil((new Date(this.cotermDate).getTime() - this.commonService.getPDTDate().getTime()) / (1000 * 3600 * 24));
        this.subscriptionItemsPendingList = [ ...pendingSubs ].map(sub => {
            sub.showProratedPrice = false;
            if (!sub.newQuantity) sub.newQuantity = sub.quantity;
            sub.totalPrice = this.commonService.toNumber(sub.newQuantity)  * this.commonService.toNumber((sub.itemPrice).replace('$', '').replace(',', ''));
          // }
          return sub
        });

        this.totalPriceChange = this.pendingTotal = 0;
        if (this.subscriptionItemsPendingList.length > 0) {
          this.totalPriceChange = this.pendingTotal = this.calculateTotalPriceChange();
        }
      });
  }

  calculateTotalPriceChange(): number {
    let totalPrice = 0;
    this.subscriptionItemsPendingList.forEach(subscription => {
      totalPrice += this.commonService.toNumber(subscription.newQuantity) * ((subscription.proratedPrice && !this.createScheduled) ? subscription.proratedPrice : this.commonService.toNumber(subscription.itemPrice.replace('$', '').replace(',', '')));
    });
    return totalPrice;
  }

  public removeSubscriptionPendingItem(index: number): void {
    this.subscriptionItemsPendingList.splice(index, 1);
    this.adobeService.monitorAMPPendingSubscriptions(this.subscriptionItemsPendingList);
    if (!this.subscriptionItemsPendingList?.length) {
      this.close();
    } else {
      this.continueComfirmProduct();
    }

  }

  confirmSubscription(): void {
    this.confirmSubscriptions = [];
    this.subscriptionItemsPendingList.forEach(annuityItem => {

      const haveExiting = this.existingCustomerSubscriptions.find(s => s.out_stock_code == annuityItem.stockCode)

      this.confirmAnnuityItemSubscription = {} as AMPubscriptionModel;
      this.currentLineItemsId += 1;

      this.confirmAnnuityItemSubscription = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: haveExiting ? haveExiting.out_subscription_id : '',
        currentQty: haveExiting ? this._decimalPipe.transform(haveExiting.out_qty, '1.0-0')?.toString() : '',
        subscriptionDescription: annuityItem.description,
        customerReference: this.poReference,
        stockDescription: annuityItem.subscriptionDescription,
        parentSubscriptionId: '',
        stockCode: annuityItem.previewStockCode,
        qty: annuityItem?.newQuantity?.toString(),
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        price: annuityItem?.itemPrice.toString(),
        totalPrice:  annuityItem?.totalPrice.toString(),
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.previewStockCode,
        chargeType: annuityItem.chargeType,
        lineItemId: this.currentLineItemsId.toString(),
        orderType: 'RENEWAL',
        inEffectivePriceDate: annuityItem.effectiveDate
      };

      if (this.confirmAnnuityItemSubscription.tenantId) {
        this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
      }
    });

    if (this.confirmSubscriptions.length) {
      this.openConfirmPendingModal();
    } else {
      this.commonService.implementToast('There is no pending subscription to confirm', 'Error');
    }
  }

  openConfirmPendingModal(): void {
    const dialogRef = this.dialog.open(ConfirmAMPSubscriptionPopup, {
      width: '650px',
      data: { totalPriceChange: this.totalPriceChange, hasProrated: false }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.poReference = result;

        if (this.confirmSubscriptions.length) {

          this.confirmSubscriptions.map(item => {
            item.customerReference = this.poReference;
          });

          this.createOrCancelAMPSubscription();

        }
      }
    });
  }

  createOrCancelAMPSubscription(): void {
    this.loadContent = false;
    this.adobeService.createOrCancelAMPSubscription(this.confirmSubscriptions)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: IAMPModifySubscriptionResponse[]) => {
          this.postAMPModifySubscriptionResponse(res)
        },
        error: (error: string) => this.commonService.implementToast(error, "Error"),
        complete: () => this.loadContent = true
      });
  }

  private postAMPModifySubscriptionResponse(list: IAMPModifySubscriptionResponse[]) {
    if (list.length) {
      this.finishSubscriptions = list;
      this.loadContent = true;
      const dialogRefFinish = this.dialog.open(FinishAMPSubscriptionComponent, {
        width: '650px',
        data: { finishSubscriptions: this.finishSubscriptions, confirmSubscriptions: this.confirmSubscriptions },
        disableClose: true
      });

      dialogRefFinish.afterClosed().subscribe(() => {
        this.subscriptionItemsPendingList = [];
        this.totalPriceChange = 0;
        this.pendingTotal = 0;
        this.adobeService.monitorAMPPendingSubscriptions([]);
        this.adobeService.refetchAMPItemsView$.next();
        if (!this.cotermDate) this.adobeService.refetchAMPTenantDetailView$.next();

        if (this.finishSubscriptions.every(sub => sub.isUpdateSuccessful == true)) {
          let urlArr = this.router.url.split("/", 6).slice(1);
          this.router.navigate([urlArr.join("/")]);
          $('#levelOne').animate({ scrollLeft: 250 }, 400);
        }
      });
    }
  }


  downloadExcelAbobeConfirmProducts(action: string, details: any) {
    this.confirmSubscriptions = [];
    this.subscriptionItemsPendingList.forEach(annuityItem => {

      const haveExiting = this.existingCustomerSubscriptions.find(s => s.out_stock_code == annuityItem.stockCode)

      this.confirmAnnuityItemSubscription = {} as AMPubscriptionModel;
      this.currentLineItemsId += 1;
      this.confirmAnnuityItemSubscription = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: haveExiting ? haveExiting.out_subscription_id : '',
        currentQty: haveExiting ? this._decimalPipe.transform(haveExiting.out_qty, '1.0-0')?.toString() : '',
        subscriptionDescription: annuityItem.description,
        customerReference: this.poReference,
        stockDescription: annuityItem.subscriptionDescription,
        parentSubscriptionId: '',
        stockCode: annuityItem.previewStockCode,
        qty: annuityItem?.newQuantity?.toString(),
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        price: annuityItem.proratedPrice?.toString(),
        totalPrice: annuityItem.proratedTotal?.toString(),
        unitCost_RRP: annuityItem.itemRRPrice,
        resellerBuy: annuityItem.itemPrice,
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.previewStockCode,
        chargeType: annuityItem.chargeType,
        lineItemId: this.currentLineItemsId?.toString(),
        orderType: 'NEW',
        inEffectivePriceDate: annuityItem.effectiveDate
      };

      if (this.confirmAnnuityItemSubscription.tenantId) {
        this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
      }
    });
    this.adobeService.downloadExcelAbobeConfirmProducts(this.confirmSubscriptions, action, details).subscribe((res: any) => {    
        //const fileName = `Adobe_Confirm_Offers`;
        var now = new Date();
        const dateTime = this.datePipe.transform(now, 'yyyy-MM-dd\'T\'HH:mm:ss');       
        const fileName = `Indicative Pricing_${dateTime}_${this.details.customer.company_name}.xlsx`;
        this.fileService.saveAsExcelFile(res, fileName);
        this.ngProgress.done();        
        this.commonService.implementToast('Report downloaded successfully', 'Success');
    });

  }

  public showCreateScheduled(): boolean {
    const daysUntilAnni = Math.round((new Date(this.cotermDate).getTime() - new Date().getTime()) / (1000 * 3600 * 24));
    const hasNonExisting = this.subscriptionItemsPendingList?.some(x => !x.isExisting);
    return (daysUntilAnni <= 30) && (daysUntilAnni >= 3) && hasNonExisting
  }

  public quantityChange(item) {
    const oldValue = this.commonService.toNumber(item.quantity);
    const newValue = this.commonService.toNumber(item.newQuantity);

    if (newValue <= oldValue) {
      this.continueComfirmProduct();
    } else {
      item.newQuantity = item.quantity;
      this.commonService.implementToast('Quantity must be less than original quantity', 'Info')
    }
  }

  private continueComfirmProduct() {
    const confirmSubscriptions = [] as AMPubscriptionModel[];

    this.subscriptionItemsPendingList.forEach(annuityItem => {

      const previewItem = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: '',
        subscriptionDescription: annuityItem.subscriptionDescription,
        stockDescription: annuityItem.description,
        parentSubscriptionId: '',
        stockCode: annuityItem.stockCode,
        qty: annuityItem?.newQuantity?.toString(),
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        price: annuityItem.itemPrice,
        totalPrice: annuityItem.totalPrice.toString(),
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.offerId,
        chargeType: annuityItem.chargeType,
        orderType: 'PREVIEW',
        inEffectivePriceDate: annuityItem.effectiveDate
      } as AMPubscriptionModel;
      
      if (previewItem.tenantId) {
        confirmSubscriptions.push(previewItem);
      }
    });

    this.loadingPreview = true;
    this.loadContent = false;
    this.adobeService.createOrCancelAMPSubscription(confirmSubscriptions)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: IAMPModifySubscriptionResponse[]) => {
          if (res.length) {
            const allExistingSKU = [ ...this.existingCustomerSubscriptions ]?.map(x=> x.out_stock_code);
            
            this.subscriptionItemsPendingList = [ ...this.subscriptionItemsPendingList ].map((item, index) => {
  
              item.isExisting = allExistingSKU.includes(item.stockCode);
              item.previewPrice = this.currencyPipe.transform(res[index].unitPrice,'AUD', 'symbol-narrow','.2-2');
              item.previewRRP = this.currencyPipe.transform(res[index].rrp, 'AUD', 'symbol-narrow','.2-2');
              item.previewStockCode = res[index].stockDescription;
              item.preivewDescription = res[index].subscriptionDescription;
              item.message = res[index].message;

              if (res[index].message != 'Successful') {
                this.commonService.implementToast((res[index].message), "Error");
              }
  
              return item
            });

            const filteredList = this.subscriptionItemsPendingList.filter(item => item.message !== 'Product not found');
            if (filteredList.length !== this.subscriptionItemsPendingList.length) {
              this.commonService.implementToast("Product not found", "Error");
              this.subscriptionItemsPendingList = filteredList;
            }

            this.adobeService.monitorAMPPendingSubscriptions(this.subscriptionItemsPendingList);
          }
          
        },
        error: (error: string) => {
          this.commonService.implementToast(error, "Error");
          this.loadingPreview = false;
          this.loadContent = true;
        },
        complete: () => {
          this.loadingPreview = false;
          this.loadContent = true;
        }
      });
  }

  public isExpanded(p: IAMPAnnuityItemsViewModel) {
    return this.expandedItem === p;
  }

  public toggle(p: IAMPAnnuityItemsViewModel) {
    this.expandedItem = this.isExpanded(p) ? null : p;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
